/**
 * Đường dẫn GỐC mà Nhật ký sử dụng AI trỏ ra ngoài. Component bọc bằng `useDuongDan()` (`hooks/useDuongDan.ts`) để có
 * tiền tố cổng, không viết thẳng `/client/...` hay `/admin/...`.
 */

/**
 * Lối xử lý lượt chưa có giá vốn hay thiếu tỷ giá: tab "Giá vốn model" của Gói & thanh toán. Chỉ cổng nền tảng có lối
 * này; tenant không thấy giá (ADR-0123 mục 1, 4).
 */
export const DUONG_BANG_GIA_NEN_TANG = '/goi-thanh-toan?tab=bang-gia-model';
